import { useFirestoreGeneral } from '../../firebase/useFirestore'
import { Fragment } from 'react';
import { FALLBACK_ROLE_COLOR } from '../../helpers/calendar/roleColorByPersona'

const UserRoleMeta = ({ userRoleId }) => {

    const userRole = useFirestoreGeneral('UserRoles', 'ID', userRoleId || '')

    // No role assigned → render nothing.
    if (!userRoleId) return null

    // Role assigned but the lookup resolved to no match → the role was deleted.
    if (Array.isArray(userRole) && userRole.length === 0) {
        return (
            <>
                <span
                    className="role-color-dot"
                    style={{ '--role-dot': FALLBACK_ROLE_COLOR }}
                />
                Onbekende rol
            </>
        )
    }

  return (
    <>
        {userRole && userRole.map(role => (
            <Fragment key={role.ID}>
                <span
                    className="role-color-dot"
                    style={{ '--role-dot': role.Color || FALLBACK_ROLE_COLOR }}
                />
                {role.Name}
            </Fragment>
        ))}
    </>
  )
}

export default UserRoleMeta
